var _clipPath, _clipPath2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFootballManagerVectorLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "68px",
    height: "68px",
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 17 L 65 17 L 65 50 L 2 50 Z M 2 17 "
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54.503906 49.238281 L 2.179688 49.238281 L 2.179688 17.699219 L 64.757812 17.699219 Z M 54.503906 49.238281 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 247.7772,
    y1: 106.2072,
    x2: 393.9377,
    y2: 556.0427,
    gradientTransform: "matrix(0.104294,0,0,-0.104294,0,68)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(19.607843%,7.843137%,31.372549%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1497,
    style: {
      stopColor: "rgb(21.176471%,7.843137%,30.980392%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2903,
    style: {
      stopColor: "rgb(25.490196%,7.45098%,29.019608%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4273,
    style: {
      stopColor: "rgb(32.941176%,6.666667%,26.27451%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5622,
    style: {
      stopColor: "rgb(43.529412%,5.490196%,21.960784%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    style: {
      stopColor: "rgb(56.862745%,4.313725%,16.862745%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8275,
    style: {
      stopColor: "rgb(73.333333%,2.745098%,10.196078%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9562,
    style: {
      stopColor: "rgb(92.941176%,0.784314%,2.745098%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,0%,0%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 2.179688 17.699219 L 64.757812 17.699219 L 64.757812 49.238281 L 2.179688 49.238281 Z M 2.179688 17.699219 "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22.257812 33.28125 C 24.3125 33.28125 24.957031 31.988281 25.011719 30.914062 C 25.03125 30.589844 25.03125 30.253906 25.011719 29.933594 C 24.945312 28.847656 24.332031 27.542969 22.257812 27.542969 C 20.179688 27.542969 19.566406 28.847656 19.503906 29.933594 C 19.480469 30.253906 19.480469 30.570312 19.503906 30.890625 C 19.566406 31.996094 20.191406 33.28125 22.257812 33.28125 Z M 21.390625 30.035156 C 21.410156 29.546875 21.621094 29.128906 22.257812 29.128906 C 22.882812 29.128906 23.101562 29.546875 23.121094 30.035156 C 23.132812 30.320312 23.132812 30.507812 23.121094 30.808594 C 23.101562 31.296875 22.882812 31.714844 22.257812 31.714844 C 21.628906 31.714844 21.410156 31.296875 21.390625 30.808594 C 21.378906 30.484375 21.378906 30.320312 21.390625 30.035156 Z M 21.390625 30.035156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 26.773438 33.15625 L 28.671875 33.15625 L 28.671875 29.285156 L 30.203125 29.285156 L 30.203125 27.679688 L 25.238281 27.679688 L 25.238281 29.285156 L 26.773438 29.285156 Z M 26.773438 33.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.335938 32.550781 C 35.5625 32.289062 35.691406 31.945312 35.679688 31.601562 C 35.710938 31.257812 35.597656 30.921875 35.367188 30.664062 C 35.1875 30.496094 34.96875 30.371094 34.742188 30.308594 C 35.21875 30.140625 35.5 29.785156 35.5 29.128906 C 35.5 28.210938 34.917969 27.679688 33.613281 27.679688 L 30.632812 27.679688 L 30.632812 33.164062 L 33.582031 33.164062 C 34.554688 33.15625 35.042969 32.882812 35.335938 32.550781 Z M 32.425781 28.910156 L 33.132812 28.910156 C 33.511719 28.910156 33.71875 28.992188 33.71875 29.371094 C 33.71875 29.746094 33.511719 29.839844 33.132812 29.839844 L 32.425781 29.839844 Z M 32.425781 31.925781 L 32.425781 30.871094 L 33.25 30.871094 C 33.605469 30.871094 33.832031 30.964844 33.832031 31.382812 C 33.832031 31.820312 33.613281 31.914062 33.25 31.914062 Z M 32.425781 31.925781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 37.628906 33.15625 L 37.847656 32.382812 L 39.777344 32.382812 L 39.996094 33.15625 L 41.9375 33.15625 L 40.082031 27.667969 L 37.503906 27.667969 L 35.667969 33.15625 Z M 38.859375 29.171875 L 39.371094 30.945312 L 38.277344 30.945312 L 38.789062 29.171875 Z M 38.859375 29.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.285156 36.316406 L 25.28125 33.65625 L 23.488281 33.65625 L 23.488281 39.257812 L 25.28125 39.257812 L 25.28125 36.542969 L 27.324219 39.257812 L 29.085938 39.257812 L 29.085938 33.65625 L 27.285156 33.65625 Z M 27.285156 36.316406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 45.378906 35.167969 L 45.878906 33.65625 L 41.394531 33.65625 L 41.394531 39.257812 L 45.390625 39.257812 L 45.878906 37.746094 L 43.230469 37.746094 L 43.230469 37.085938 L 44.753906 37.085938 L 45.171875 35.804688 L 43.230469 35.804688 L 43.230469 35.167969 Z M 45.378906 35.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 44.167969 31.550781 L 44.167969 27.679688 L 42.269531 27.679688 L 42.269531 33.15625 L 45.992188 33.15625 L 46.515625 31.550781 Z M 44.167969 31.550781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 37.996094 37.160156 L 39.257812 37.160156 L 39.257812 37.734375 C 38.984375 37.796875 38.714844 37.828125 38.441406 37.828125 C 37.648438 37.828125 37.390625 37.378906 37.359375 36.941406 C 37.335938 36.617188 37.335938 36.304688 37.359375 35.980469 C 37.378906 35.554688 37.578125 35.148438 38.609375 35.148438 C 39.132812 35.15625 39.640625 35.199219 40.152344 35.28125 L 40.613281 33.78125 C 39.871094 33.613281 39.121094 33.53125 38.359375 33.542969 C 36.347656 33.542969 35.617188 34.480469 35.449219 35.855469 C 35.417969 36.242188 35.417969 36.636719 35.449219 37.023438 C 35.511719 38.058594 36.085938 39.390625 38.109375 39.390625 C 39.058594 39.402344 40.007812 39.234375 40.894531 38.890625 L 40.894531 35.804688 L 38.453125 35.804688 Z M 37.996094 37.160156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.125 39.257812 L 49.894531 37.203125 C 50.207031 37.097656 50.488281 36.898438 50.6875 36.628906 C 50.925781 36.304688 51.042969 35.910156 51.03125 35.511719 C 51.050781 35.105469 50.9375 34.710938 50.6875 34.386719 C 50.382812 33.988281 49.894531 33.644531 48.914062 33.644531 L 46.148438 33.644531 L 46.148438 39.246094 L 47.984375 39.246094 L 47.984375 37.148438 L 49.152344 39.246094 Z M 47.984375 36.285156 L 47.984375 35.167969 L 48.589844 35.167969 C 49.027344 35.167969 49.214844 35.28125 49.214844 35.742188 C 49.214844 36.179688 49.027344 36.285156 48.589844 36.285156 Z M 47.984375 36.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.453125 33.65625 L 12.671875 36.285156 L 11.859375 33.65625 L 9.617188 33.65625 L 8.59375 39.257812 L 10.535156 39.257812 L 10.972656 36.042969 L 12.015625 39.257812 L 13.328125 39.257812 L 14.382812 36.097656 L 14.746094 39.257812 L 16.707031 39.257812 L 15.6875 33.65625 Z M 13.453125 33.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.867188 31.664062 L 12.410156 31.664062 L 12.890625 30.191406 L 10.867188 30.191406 L 10.867188 29.285156 L 13.183594 29.285156 L 13.703125 27.679688 L 8.96875 27.679688 L 8.96875 33.15625 L 10.867188 33.15625 Z M 10.867188 31.664062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.527344 30.914062 C 13.601562 31.988281 14.214844 33.28125 16.28125 33.28125 C 18.335938 33.28125 18.972656 31.988281 19.035156 30.890625 C 19.054688 30.570312 19.054688 30.253906 19.035156 29.933594 C 18.972656 28.847656 18.386719 27.542969 16.28125 27.542969 C 14.203125 27.542969 13.578125 28.847656 13.527344 29.933594 C 13.507812 30.265625 13.507812 30.589844 13.527344 30.914062 Z M 15.414062 30.046875 C 15.4375 29.558594 15.632812 29.140625 16.28125 29.140625 C 16.90625 29.140625 17.125 29.558594 17.144531 30.046875 C 17.15625 30.339844 17.15625 30.507812 17.144531 30.808594 C 17.125 31.296875 16.90625 31.714844 16.28125 31.714844 C 15.65625 31.714844 15.4375 31.296875 15.414062 30.808594 C 15.402344 30.496094 15.402344 30.320312 15.414062 30.046875 Z M 15.414062 30.046875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 31.195312 33.65625 L 29.410156 39.257812 L 31.371094 39.257812 L 31.582031 38.472656 L 33.4375 38.472656 L 33.644531 39.257812 L 35.585938 39.257812 L 33.800781 33.65625 Z M 31.988281 36.992188 L 32.476562 35.167969 L 32.550781 35.167969 L 33.039062 36.992188 Z M 31.988281 36.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.753906 33.65625 L 16.96875 39.257812 L 18.929688 39.257812 L 19.136719 38.472656 L 20.996094 38.472656 L 21.203125 39.257812 L 23.152344 39.257812 L 21.371094 33.65625 Z M 19.542969 36.992188 L 20.035156 35.167969 L 20.109375 35.167969 L 20.597656 36.992188 Z M 19.542969 36.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 48.726562 31.550781 L 48.726562 27.679688 L 46.839844 27.679688 L 46.839844 33.15625 L 50.550781 33.15625 L 51.074219 31.550781 Z M 48.726562 31.550781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.957031 27.824219 L 49.957031 28.234375 L 49.757812 28.234375 L 49.757812 27.824219 L 49.539062 27.824219 L 49.539062 27.667969 L 50.164062 27.667969 L 50.164062 27.824219 Z M 49.957031 27.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 50.53125 27.667969 L 50.636719 27.949219 C 50.644531 27.972656 50.65625 27.992188 50.65625 28.023438 C 50.65625 28.003906 50.667969 27.972656 50.675781 27.949219 L 50.769531 27.667969 L 51.074219 27.667969 L 51.074219 28.222656 L 50.894531 28.222656 L 50.894531 27.917969 C 50.894531 27.878906 50.894531 27.835938 50.90625 27.804688 C 50.894531 27.847656 50.886719 27.878906 50.863281 27.917969 L 50.738281 28.234375 L 50.550781 28.234375 L 50.4375 27.917969 C 50.414062 27.878906 50.40625 27.835938 50.40625 27.804688 C 50.414062 27.847656 50.414062 27.878906 50.414062 27.917969 L 50.414062 28.222656 L 50.238281 28.222656 L 50.238281 27.667969 Z M 50.53125 27.667969 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballManagerVectorLogo);
export default __webpack_public_path__ + "static/media/football-manager-vector-logo.f18e3c3e3747570c3b4a5c1d49b46702.svg";
export { ForwardRef as ReactComponent };